import { render, staticRenderFns } from "./SaleEdit.vue?vue&type=template&id=724fb670&scoped=true&"
import script from "./SaleEdit.vue?vue&type=script&lang=js&"
export * from "./SaleEdit.vue?vue&type=script&lang=js&"
import style0 from "./SaleEdit.vue?vue&type=style&index=0&id=724fb670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724fb670",
  null
  
)

export default component.exports